import { skusActions } from "../actions/skus";

const initialState = Object.freeze({});

const skus = (state = initialState, action) => {
  switch (action.type) {
    case skusActions.FETCH_SKUS_SUCCESS: {
      const { skus, productId } = action.payload;
      return {
        ...state,
        [productId]: skus,
      };
    }
    default:
      return state;
  }
};

export default skus;
